import React, { useCallback, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import '../../styles/imagePageStyles.css'

export default function Technovation() {
  const images = [
    require("../../images/Technovation/technovation (1).jpeg"),
    require("../../images/Technovation/technovation (1).jpg"),
    require("../../images/Technovation/technovation (2).jpeg"),
    require("../../images/Technovation/technovation (3).jpeg"),
    require("../../images/Technovation/technovation (4).jpeg"),
    require("../../images/Technovation/technovation (5).jpeg"),
    require("../../images/Technovation/technovation (6).jpeg"),
    require("../../images/Technovation/technovation (7).jpeg"),
    
  ];

  return (
    <div className="technovation">

      {/* <Carousel
        showArrows={true}
        onChange={() => {}}
        useKeyboardArrows
        renderItem={(props) => {
            let { alt, src } = props?.props
            return (
                <img className="image-item" src={src} alt={alt}/>
            )
        }}
        axis="horizontal"
        showThumbs
        animationHandler={'fade'}
        autoPlay
        interval={5000}
        // infiniteLoop
      >
        
        {images.map((src, index) => (
        <img
          src={src}
          alt="technovation image"
        //   onClick={() => openImageViewer(index)}
          width="300"
          height={'300'}
          key={index}
          style={{ margin: "2px" }}
        />
      ))}

      </Carousel> */}

      <div className="images">
      {images.map((src, index) => (
        <img
          src={src}
          alt="technovation image"
        //   onClick={() => openImageViewer(index)}
          width="300"
          height={'300'}
          key={index}
          style={{ margin: "2px" }}
        />
      ))}
      </div>
    </div>
  );
}
